export default "/images/Additives.webp?a82a35971b1afa16c64f79d51e3a428e";